export interface AuthorityItem {
  authorityNo: string
  tag: string
  display: string
  displayKana: string
}

export const defaultAuthorityItem = (): AuthorityItem => ({
  authorityNo: '',
  tag: '',
  display: '',
  displayKana: ''
})

export const AuthorityType = {
  Author: 'author',
  Publisher: 'publisher',
  Subject: 'subject',
  CompleteWorks: 'complete_works',
  Series: 'series'
}
export type AuthorityType = typeof AuthorityType[keyof typeof AuthorityType]

export interface AuthorityTypeItem {
  label: string
  name: string
  nameKana: string
  crossReferenceLikeTag: string
}

export function AuthorityTypeItem(
  authorityType: AuthorityType
): AuthorityTypeItem {
  switch (authorityType) {
    case AuthorityType.Author:
      return {
        label: '責任表示',
        name: 'W00001050001020001',
        nameKana: 'W00001050001050001',
        crossReferenceLikeTag: 'W0000106000101nnnn'
      }
    case AuthorityType.Publisher:
      return {
        label: '出版者',
        name: 'SP0001050001020001',
        nameKana: 'SP0001050001050001',
        crossReferenceLikeTag: 'SP000106000101nnnn'
      }
    case AuthorityType.Subject:
      return {
        label: '件名',
        name: 'KM0001050001020001',
        nameKana: 'KM0001050001050001',
        crossReferenceLikeTag: 'KM000106000101nnnn'
      }
    case AuthorityType.CompleteWorks:
      return {
        label: '全集',
        name: 'Z00001050001020001',
        nameKana: 'Z00001050001050001',
        crossReferenceLikeTag: 'Z0000106000101nnnn'
      }
    case AuthorityType.Series:
      return {
        label: 'シリーズ',
        name: 'S00001050001020001',
        nameKana: 'S00001050001050001',
        crossReferenceLikeTag: 'S0000106000101nnnn'
      }
    default:
      return {
        label: '',
        name: '',
        nameKana: '',
        crossReferenceLikeTag: ''
      }
  }
}
